import { create } from 'zustand'

const initialState = {
  isTranslationActive: false,
  selectedLanguage: null,
  translationLanguages: []
}

const useAuthoringTranslations = create((set) => ({
  ...initialState,
  setIsTranslationActive: (isTranslationActive) => set({ isTranslationActive }),
  setTranslationLanguages: (translationLanguages) => set({ translationLanguages }),
  setSelectedLanguage: (selectedLanguage) => set({ selectedLanguage }),
  resetAuthoringTranslations: () => set(initialState),
}))

export default useAuthoringTranslations;